import React from 'react';
import CommonTermsPage, { WEBSITE, EMAIL, DIETA_NIEMOWLAKA_DATA } from './CommonTermsPage';

const privacySections = [
  {
    heading: '1. Postanowienia Ogólne',
    content: `Niniejsza polityka prywatności określa zasady przetwarzania danych osobowych użytkowników aplikacji „Dieta Niemowlaka”, prowadzonej przez ${DIETA_NIEMOWLAKA_DATA}.`,
  },
  {
    heading: '2. Zakres Danych',
    content: 'Przetwarzamy dane osobowe użytkowników w zakresie niezbędnym do świadczenia usług oferowanych przez aplikację.',
  },
  {
    heading: '3. Cel Przetwarzania Danych',
    content: 'Dane osobowe są przetwarzane w celu realizacji usług, kontaktu z użytkownikami oraz w celach marketingowych.',
  },
  {
    heading: '4. Prawa Użytkowników',
    content: 'Użytkownicy mają prawo do wglądu, poprawiania oraz usunięcia swoich danych osobowych.',
  },
  {
    heading: '5. Zmiany w Polityce Prywatności',
    content: `Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej polityce prywatności. O wszelkich zmianach użytkownicy będą informowani poprzez stronę ${WEBSITE}.`,
  },
  {
    heading: '6. Kontakt',
    content: `W razie pytań prosimy o kontakt pod adresem: ${EMAIL}.`,
  },
];

const PrivacyPolicy = () => {
  return <CommonTermsPage title="Polityka Prywatności" sections={privacySections} />;
};

export default PrivacyPolicy;